import styled, { x } from '@xstyled/styled-components';
import React, { useEffect, useState } from 'react';
import { t } from 'ttag';
import { select } from '~/lib/select';
import { Button } from '~/ui/buttons/Button';
import { Flex } from '~/ui/flex/Flex';
import { LlamaModal } from '~/ui/llama-modal/LlamaModal';
import { TrainingState, useTrainingStore } from '../state';
import { OnboardingStages, useOnboardingStore } from './Store';

const selector = (s: TrainingState) =>
  select(
    s,
    'firstName',
    'companyName',
    'logoUrl',
    'title',
    'setFirstName',
    'askName',
    'textLocales',
    'shouldDisplayCourseDurationCard',
    'disclaimer',
    'scorePassingPercent'
  );

const Input = styled.input`
  background-color: lightgray;
  padding: 10px;
  border-radius: 15px;
  width: 80%;
`;

const Label = styled.label`
  display: block;
  margin: 0;
  font: inherit;
  color: inherit;
  text-align: center;
  cursor: text;
`;

export const Username = () => {
  const {
    firstName,
    setFirstName,
    askName,
    shouldDisplayCourseDurationCard,
    disclaimer,
    scorePassingPercent
  } = useTrainingStore(selector);

  const { stage, goTo } = useOnboardingStore(({ stage, goTo }) => ({
    stage,
    goTo
  }));

  useEffect(() => {
    if (stage == OnboardingStages.Username && !askName) {
      if (shouldDisplayCourseDurationCard) {
        return goTo(OnboardingStages.CourseDuration);
      } else if (disclaimer) {
        return goTo(OnboardingStages.Disclaimer);
      } else if (scorePassingPercent && scorePassingPercent > 0) {
        return goTo(OnboardingStages.PassFail);
      } else {
        return goTo(OnboardingStages.Autosaving);
      }
    }
  }, [stage]);

  const [userName, setUserName] = useState(firstName);

  const goNext = () => {
    const trimmed = userName.trim();
    if (!trimmed) return;

    setFirstName(trimmed);

    if (shouldDisplayCourseDurationCard) {
      return goTo(OnboardingStages.CourseDuration);
    } else if (disclaimer) {
      return goTo(OnboardingStages.Disclaimer);
    } else if (scorePassingPercent && scorePassingPercent > 0) {
      return goTo(OnboardingStages.PassFail);
    } else {
      return goTo(OnboardingStages.Autosaving);
    }
  };

  return (
    <>
      {stage === OnboardingStages.Username && (
        <LlamaModal horizontal="center" vertical="center" allowScroll>
          <Flex
            data-test-id="username-card"
            w="md"
            minHeight="md"
            flexDirection="column"
            p="xl"
            alignItems="center"
            justifyContent="space-between"
          >
            <x.h2 textAlign="center" fontFamily="llama">{t`About you`}</x.h2>
            <Label htmlFor="userName">{t`Before we start, what should I call you?`}</Label>
            <Input
              id="userName"
              type="text"
              name="username"
              value={userName}
              placeholder={t`Type here`}
              aria-required="true"
              autoComplete="name"
              onChange={e => {
                setUserName(e.target.value);
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  goNext();
                }
              }}
            />
            <Button
              onClick={goNext}
              disabled={!userName.trim()}
              data-test-id="continue-button"
            >{t`Continue`}</Button>
          </Flex>
        </LlamaModal>
      )}
    </>
  );
};
